<po-page-default p-title="Notas fiscais">
  <po-table
    *ngIf="!isMobile"
    [p-columns]="columns"
    [p-items]="items"
    p-container="border"
    [p-sort]="true"
    [p-literals]="customLiterals"
    [p-striped]="true"
    [p-actions-right]="true"
  >
  </po-table>

  <div *ngIf="isMobile" class="mobile-invoice-viewport po-p-2">
    <div class="invoice-card reveal" *ngFor="let item of items">
      <div class="card-section header-bg">
        <div class="po-row">
          <div class="po-sm-12" *ngIf="item.personName">
            <span class="label-muted">DESTINATÁRIO</span>
            <h3 class="value-highlight">{{ item.personName }}</h3>
          </div>
          <div class="po-sm-6">
            <span class="label-muted">NOTA FISCAL</span>
            <span class="value-small">{{ item.invoiceCode }}</span>
          </div>
          <div class="po-sm-6 text-right">
            <span class="label-muted">SÉRIE</span>
            <span class="value-small">{{ item.serialCode }}</span>
          </div>
        </div>
      </div>
      <div class="card-section border-y">
        <div class="po-row po-mb-2">
          <div class="po-sm-6">
            <span class="label-muted">EMISSÃO</span>
            <span class="value-data">{{
              item.issueDate | date: "dd/MM/yyyy"
            }}</span>
          </div>
          <div class="po-sm-6 text-right">
            <span class="label-muted">MODELO</span>
            <span class="value-data">{{ item.documentType }}</span>
          </div>
        </div>
        <div class="po-row">
          <div class="po-sm-12">
            <span class="label-muted">CHAVE DE ACESSO</span>
            <span class="value-key po-text-ellipsis">{{ item.accessKey }}</span>
          </div>
        </div>
      </div>
      <div class="card-section bg-neutral-soft">
        <div class="po-row po-align-items-center">
          <div class="po-sm-12">
            <span class="label-muted">TOTAL DA NOTA</span>
            <span class="value-total">{{
              item.totalValue | currency: "BRL" : "symbol" : "1.2-2" : "pt-BR"
            }}</span>
          </div>
        </div>
      </div>
      <div class="card-section footer-actions">
        <div
          class="action-grid"
          [class.single-column]="
            item.documentType === 'S@T' || item.documentType === 'NFC-e'
          "
        >
          <button class="btn-action-lux" (click)="downloadXml(item)">
            <i class="ph ph-file-xml"></i>
            <span>XML</span>
          </button>
          <button
            *ngIf="item.documentType !== 'S@T' && item.documentType !== 'NFC-e'"
            class="btn-action-lux"
            (click)="downloadDanfe(item)"
          >
            <i class="ph ph-file-pdf"></i>
            <span>DANFE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-pagination
    [pCurrentPage]="currentPage"
    [pTotalItems]="totalItems"
    [pPageSize]="pageSize"
    [pTotalPages]="totalPages"
    (pChangePage)="onPageChange($event.page, $event.pageSize)"
  >
  </app-pagination>

  <div class="sample-container">
    <po-loading-overlay
      [p-screen-lock]="true"
      [hidden]="isLoadingHidden"
      [p-size]="loadingSize"
      [p-text]="loadingText"
    >
    </po-loading-overlay>
  </div>
  <div class="po-row widget-row"></div>
  <!-- <last-menu-acess></last-menu-acess> -->
</po-page-default>
